import React from 'react';
import PropTypes from 'prop-types';
import styled, { ThemeProvider } from 'styled-components';
import { inject, observer } from 'mobx-react';

import Title from '../../components/Title/';
import Scene from '../Scene';
import Container from '../../components/Container';
import Indent from '../../components/Indent';
import { toVw, toVwMobile, toVwTablet } from '../../utils/styles';
import Carousel from '../../components/Carousel/';
import Links from '../../components/Links';
import ContactsOffices from './components/ContactsOffices';
import theme from '../../utils/theme';
import mq from '@/utils/media-queries';
import AnimationOnPageLoadItem from '../../components/AnimationOnPageLoadItem';

const PADDING_TOP = 265;
const PADDING_BOTTOM = 278;

const ContactsScene = styled(Scene)`
  padding-top: ${toVw(PADDING_TOP)};
  padding-bottom: ${toVw(PADDING_BOTTOM)};

  ${mq.tablet(css`
    padding-top: ${toVwTablet(PADDING_TOP)};
    padding-bottom: ${toVwTablet(PADDING_BOTTOM)};
  `)};

  ${mq.mobile(css`
    padding-top: ${toVwMobile(PADDING_TOP)};
    padding-bottom: ${toVwMobile(PADDING_BOTTOM)};
  `)};
`;

const StyledTitle = styled(Title)`
  margin-bottom: ${toVw(122)};
`;

const MapCarousel = styled(Carousel)`
  margin-bottom: ${toVw(180)};
`;

const StyledOffices = styled(ContactsOffices)`
  margin-bottom: ${toVw(104)};

  ${mq.mobile(css`
    margin-bottom: ${toVwMobile(50)};
  `)};
`;

class Contacts extends React.Component {
  static propTypes = {
    mapsStore: PropTypes.object.isRequired,
    officesStore: PropTypes.object.isRequired,
  };

  componentDidMount() {
    this.props.mapsStore.load();
    this.props.officesStore.load();
  }

  render() {
    return (
      <ContactsScene dark {...this.props}>
        <Container>
          <Indent>
            <AnimationOnPageLoadItem>
              <StyledTitle>
                Say hello to
                <br />
                New York office
                <br />
                soon
              </StyledTitle>
            </AnimationOnPageLoadItem>
          </Indent>
          <AnimationOnPageLoadItem>
            <MapCarousel items={this.props.mapsStore.items.toJSON()} />
          </AnimationOnPageLoadItem>
          <Indent>
            <StyledOffices items={this.props.officesStore.items.toJSON()} />
            <Links />
          </Indent>
        </Container>
      </ContactsScene>
    );
  }
}

export default inject(stores => ({
  mapsStore: stores.store.maps,
  officesStore: stores.store.offices,
}))(observer(Contacts));



// WEBPACK FOOTER //
// ./src/scenes/Contacts/index.js